// Redux Form
import { SubmissionError } from 'redux-form';

// Fetch Request
import fetch from '../../../core/fetch';

// Language
import messages from './messages';

// Toaster
import { toastr } from 'react-redux-toastr';

// Redirection
import history from '../../../core/history';

async function submit(values, dispatch) {

  const query = `
  query (
    $profileId:Int!,
    $companyName:String,
    $firstName:String,
    $lastName:String,
    $address1:String,
    $address2:String,
    $city:String,
    $zip:String,
    $taxId:String,
    $dateOfBirth:String,
    $gender:String,
    $phoneNumber: String,
    $preferredLanguage: String,
    $preferredCurrency: String,
    $location: String,
    $info: String,
  ) {
    updateUser (
      profileId:$profileId,
      companyName: $companyName,
      firstName: $firstName,
      lastName: $lastName,
      address1:$address1,
      address2:$address2,
      city:$city,
      zip:$zip,
      taxId:$taxId,
      dateOfBirth: $dateOfBirth,
      gender: $gender,
      phoneNumber: $phoneNumber,
      preferredLanguage: $preferredLanguage,
      preferredCurrency: $preferredCurrency,
      location: $location,
      info: $info,
      region: $region,
    ) {
      status
    }
  }
  `;

  const params = {
    profileId: values.profileId,
    companyName: values.companyName,
    address1: values.address1,
    address2: values.address2,
    city: values.city,
    zip: values.zip,
    taxId: values.taxId,
    firstName: values.firstName,
    lastName: values.lastName,
    gender: values.gender,
    dateOfBirth: values.dateOfBirth,
    phoneNumber: values.phoneNumber,
    preferredLanguage: values.preferredLanguage,
    preferredCurrency: values.preferredCurrency,
    location: values.location,
    info: values.info,
    region: values.region,
  };

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: params
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateUser.status === "success") {
    toastr.success("Update Profile", "Changes are updated!");
    history.push('/siteadmin/users');
  } else {
    throw new SubmissionError({ _error: messages.somethingWentWrong });
  }

}

export default submit;
